/* import __COLOCATED_TEMPLATE__ from './health-cell.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import templateOnlyComponent from '@ember/component/template-only';

import type { ActionHealth } from 'embercom/models/workflow-connector/setup-action';

interface Signature {
  Args: {
    health: ActionHealth | null;
  };
  Element: Element;
}

const HealthCell = templateOnlyComponent<Signature>();
export default HealthCell;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::HealthCell': typeof HealthCell;
    'workflow-connector/health-cell': typeof HealthCell;
  }
}
